import Vue from 'vue'
import Vuex from 'vuex'
import { fetchUserInfo, findRoles, getOrgRoles } from "@/apis/auth";
import { getClient, isClient } from "@/utils/client";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    accessToken: localStorage.getItem('accessToken') || '',
    userInfo: {},
    userRoles: {},
    orgRoles: [],
    client: getClient(),
    isClient,
    isShowAppCenter: false,
    fontSize: +(localStorage.getItem("_fontSize") || 16)
  },
  getters: {
    userId: state => state.userInfo.current?.id || "",
    organization: state => state.userInfo.current?.organization || {},
    organizationList: state => state.userInfo.additions || [],
    permissions: state => state.userInfo.permissions || [],
    hasDocPermission: (state, getters) => getters.permissions.some(i => i.resourceTitle.includes('公文交换')),
    hasMeetingPermission: (state, getters) => getters.permissions.some(i => i.resourceTitle.includes('会务')),
    rolesList: (state) => Object.values(state.userRoles).map(i => i.name),
    rolesLabel: (state) => Object.values(state.userRoles).map(i => i.label),
    rolesMap: (state) => state.orgRoles.reduce((result, item) => {
      result[item.id] = item
      return result
    }, {})
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setUserRoles(state, roles) {
      state.userRoles = roles
    },
    setOrgRoles(state, roles) {
      state.orgRoles = roles
    },
    setAppCenter(state, status) {
      state.isShowAppCenter = status
    },
    setFontSize(state, size) {
      state.fontSize = size
    }
  },
  actions: {
    // 获取用户信息
    async getUserInfo({ state, commit }) {
      if (Object.keys(state.userInfo).length !== 0) return state.userInfo

      const { error, data } = await fetchUserInfo()
      if (error) return

      commit('setUserInfo', data)
      return data
    },
    // 获取单位角色列表
    async getOrgRoles({ state, commit }) {
      if (state.orgRoles.length) return
      const { error, data } = await getOrgRoles({ page: 0, size: 9999 })
      if (error) return

      commit('setOrgRoles', data.content)
      return data
    },
    // 获取用户角色
    async getRoles(context) {
      if (Object.keys(context.state.userRoles).length !== 0) return

      const { error, data } = await findRoles()
      if (error) return

      context.commit('setUserRoles', data)
      return data
    },
    // 打开应用弹窗
    openAppCenter({ commit }) {
      commit('setAppCenter', true)
    },
    // 关闭应用弹窗
    closeAppCenter({ commit }) {
      commit('setAppCenter', false)
    },
    changeFontSize({ commit }, val) {
      localStorage.setItem('_fontSize', val)
      commit('setFontSize', val)
      document.documentElement.style.fontSize = val + "px";
      if (window.frames[0])
        window.frames[0].document.documentElement.style.fontSize = val + "px";
    },
  },
  modules: {
  }
})
